import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Alert, AlertDescription } from "./ui/alert";
import { Info } from "lucide-react";

const WelcomeNoRole = ({ userProfile }) => {
  return (
    <div className="min-h-screen flex items-center justify-center py-8">
      <div className="w-full max-w-md">
        <Card>
          <CardHeader className="text-center">
            <CardTitle>Welcome, {userProfile?.name}!</CardTitle>
          </CardHeader>
          <CardContent>
            <Alert>
              <Info className="h-4 w-4" />
              <AlertDescription>
                Your account has been created successfully. Please contact your
                organization administrator to assign you appropriate roles and
                permissions to access the system.
              </AlertDescription>
            </Alert>

            <div className="mt-4 p-4 bg-muted rounded-md">
              <h3 className="font-medium mb-2">What happens next?</h3>
              <ul className="text-body-small text-muted-foreground space-y-1">
                <li>• An administrator will assign you to an organization</li>
                <li>
                  • You may be assigned as a Business Unit Head or Business User
                </li>
                <li>
                  • Once assigned, you'll have access to relevant features
                </li>
              </ul>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default WelcomeNoRole;
